<qvs-status-screen
  class="qvs-validate-payment-order-request-failed"
  [title]="'shared.status-screen.ERROR' | translate"
  [type]="statusScreenType.FAILED"
  [closeButtonText]="'payments.BACK' | translate"
  (closed)="close()"
>
  <ng-container [ngSwitch]="ordersPaymentRequest?.status">
    <h2 class="qvs-validate-payment-order-request-failed__title">
      <ng-container *ngSwitchCase="'DECLINED'">
        {{ 'payments.PAYMENT_AUTHORIZATION_REJECTED' | translate }}
      </ng-container>
      <ng-container *ngSwitchCase="'UNREGISTERED_TIMED_OUT'">
        {{ 'payments.PAYMENT_AUTHORIZATION_EXPIRED' | translate }}
      </ng-container>
      <ng-container *ngSwitchCase="'USER_MAX_STATUS_UPDATE_FAILURE'">
        {{ 'payments.PAYMENT_USER_MAX_STATUS_UPDATE_FAILURE' | translate }}
      </ng-container>
      <ng-container *ngSwitchDefault>
        {{ 'payments.PAYMENT_FAILED' | translate }}
      </ng-container>
    </h2>
    <p class="qvs-validate-payment-order-request-failed__description">
      <ng-container *ngSwitchCase="'DECLINED'">
        {{ 'payments.PAYMENT_AUTHORIZATION_REJECTED_DESCRIPTION' | translate }}
      </ng-container>
      <ng-container *ngSwitchCase="'UNREGISTERED_TIMED_OUT'">
        {{ 'payments.PAYMENT_AUTHORIZATION_EXPIRED_DESCRIPTION' | translate }}</ng-container
      >
      <ng-container *ngSwitchCase="'USER_MAX_STATUS_UPDATE_FAILURE'">
        {{ 'payments.PAYMENT_USER_MAX_STATUS_UPDATE_FAILURE_DESCRIPTION' | translate }}
      </ng-container>
      <ng-container *ngSwitchDefault>
        {{ 'payments.PAYMENT_FAILED_DESCRIPTION' | translate }}
      </ng-container>
    </p>
    <qvs-request-contact
      [text]="'shared.status-screen.CONTACT_SUPPORT' | translate"
      (buttonClick)="close()"
    ></qvs-request-contact>
  </ng-container>
</qvs-status-screen>
